module.exports = __webpack_public_path__ + "static/img/til05.c3a28ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til05.png
// module id = Ynj9
// module chunks = 1